module.exports = __webpack_public_path__ + "img/图像卡.6b1aa686.png";